import * as React from 'react';
import { Route, RouteProps, Redirect, RouteComponentProps } from 'react-router-dom';
import { UserRoles } from '../../models/UserRole';
import UserDetails from '../../models/UserDetails';
import SearchListData from 'src/models/SearchListData';
import Authorization from 'src/util/Authorization';

type RouteComponent = RouteProps['component'];

export interface IRouterPrivateProps {
    isLoggedIn: boolean;
    roles?: Array<UserRoles>;
    permissions?: string[];
    user?: UserDetails;
    searchFilterData?: SearchListData[];
    filterTownships?: boolean;
    filterTracts?: boolean;
    refreshTags?: () => void;
    showPanel?: (show: boolean) => void;
}

const RoutePrivate: React.FunctionComponent<RouteProps & IRouterPrivateProps> = ({ component, ...rest }) => {
    const renderFn = (Component?: RouteComponent) => (props: RouteComponentProps) => {
        if (!Component) {
            return null;
        }

        if (!rest.isLoggedIn) {
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }

        const hasRequiredPermission =
            rest.permissions === undefined ||
            (rest.permissions.length > 0 && !!rest.user && Authorization.HasAnyPermission(rest.permissions, rest.user));

        return hasRequiredPermission ? (
            <Component {...{ ...props, ...rest }} />
        ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        );
    };

    return <Route {...rest} render={renderFn(component)} />;
};

export default RoutePrivate;



// WEBPACK FOOTER //
// ./src/components/router/RoutePrivate.tsx